export default {
  title: 'Welcome to The Louisiana ',
  subTitle: 'You are seated at',
  table: 'Table',
  or: 'OR',
};
